(function () {
var $2ad543449db2dedb$var$clipboard = {
    init: function() {
        var copyButtons = document.querySelectorAll('[data-clipboard-text]');
        if (!copyButtons.length) return;
        copyButtons.forEach(function(button) {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                var text = button.getAttribute('data-clipboard-text');
                navigator.clipboard.writeText(text);
            });
        });
    }
};
var $2ad543449db2dedb$export$2e2bcd8739ae039 = $2ad543449db2dedb$var$clipboard;


document.addEventListener('DOMContentLoaded', function() {
    (0, $2ad543449db2dedb$export$2e2bcd8739ae039).init();
});

})();
//# sourceMappingURL=scripts.js.map
